import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { OFFER_PREVIEW_FRAGMENT } from 'graphql/fragments/offer-preview';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const CREATE_OFFER_PREVIEW_MUTATION = gql`
  mutation createOfferPreview(
    $offerDocumentId: DocumentVersionInput!
    $settings: OfferPreviewSettingsInput!
    $language: String!
  ) {
    createOfferPreview( data: {
      offerDocumentId: $offerDocumentId
      settings: $settings,
      language: $language
    }
    ) {
      ...OfferPreviewFragment
    }
  }
  ${OFFER_PREVIEW_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class CreateOfferPreviewMutation extends Mutation<RootMutation> {
  document = CREATE_OFFER_PREVIEW_MUTATION;
}
